import React from "react";
import {FaLocationDot} from 'react-icons/fa6';
import {HiMiniSquares2X2} from 'react-icons/hi2';

import "./Tile.css"

const Tile: React.FC<{text: string, type: string, onClick: ()=>void}> = (props) => {

    return (
        <div className = "tile-container" onClick={props.onClick}>
            {props.type == 'location'
                ? <FaLocationDot size={24}/>
                : <HiMiniSquares2X2 size={24}/>}
            <span>{props.text}</span>
        </div>
    )
}

export default Tile;